import React, { useState, useContext, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Global } from "../../App";
import Tool_tabs from "../../Components/Tools/Tool_tabs";
import PerfectScrollbar from "react-perfect-scrollbar";
import { FormattedMessage } from "react-intl";
import { CusButton } from "../../Components/From/Button";
import { CusInput } from "../../Components/From/Input";
import {
  AsyncModel,
  AsyncModelClose,
} from "../../Components/AsyncModel/AsyncModel";
import ReactLoading from "react-loading";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import cls from "classnames";
import {
  isIOS,
  isAndroid,
  isSafari,
  isChrome,
  isFirefox,
  browserName,
  browserVersion,
} from "react-device-detect";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";

// api
import { getOrderList, getOrderDetail } from "../../Api/staff/GetOrderInfo";
import Tool_storeName from "../../Components/Tools/Tool_storeName";
import numeral from "numeral";

function StaffSearchOrder(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    selectedTab: "firstorder",
    isLogin: false,
    isSearching: false,
    isShowBlock: true,
    dataPicker: {
      selectTime: moment().format("YYYY/MM/DD"),
    },
    dropDown: {
      toggle: false,
      selectItem: { value: 1 },
    },
    searchInput: "",
    orderList: [],
  });
  const verifyItems = [
    {
      title: (
        <FormattedMessage id="pages.staffCheckOrder.step2.tabs.firstorder" />
      ),
      info: "firstorder",
      className: "staff-check-step2-use-qr",
      Type: false,
    },
    {
      title: <FormattedMessage id="pages.staffCheckOrder.step2.tabs.follow" />,
      info: "follow",
      className: "staff-check-step2-use-code",
      Type: true,
    },
  ];

  async function apiOrderList(storeId, langId, date, status) {
    try {
      const res = await getOrderList(storeId, langId, date, status);
      const { errCode, orderListItem } = res.data;
      if (errCode == 200) {
        return orderListItem;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/staff/error");
      }
    } catch (err) {
      console.error("OrderList error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 418 }],
      });
      props.history.push("/staff/error");
    }
  }
  async function apiOrderDetail(orderCode, langId, storeID, createAt) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false,
    });
    try {
      const res = await getOrderDetail(orderCode, langId, storeID, createAt);
      const { errCode, productList } = res.data;
      AsyncModelClose();
      if (errCode == 200) {
        return productList;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/staff/error");
      }
    } catch (err) {
      console.error("OrderDetail error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 414 }],
      });
      props.history.push("/staff/error");
    }
  }

  // 檢查是否有登入
  useEffect(() => {
    const handle = async () => {
      let { checkOrderBranch, checkOrderGroup, checkOrderStaff } =
        globalState.staffInfo;
      if (!checkOrderBranch || !checkOrderGroup || !checkOrderStaff) {
        // setState(curr => {
        //   let newState = { ...curr };
        //   newState.popup.toggle = true;
        //   return newState;
        // });
        const alert = await AsyncModel({
          title: globalState.langFile["popup.msgLoginWarning"],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
        if (alert) {
          dispatchGlobal({ type: "RESET" });
          props.history.replace("/staffCheckOrder");
        }
      } else {
        setState((curr) => {
          let newState = { ...curr };
          newState.isLogin = true;
          return newState;
        });
      }
    };
    handle();
  }, []);
  useEffect(() => {
    if (globalState.staffInfo.orderCode) {
      props.history.replace("/staffOrderDetail");
    }
  }, [globalState.staffInfo.orderCode]);
  useEffect(() => {
    setState((curr) => {
      return {
        ...curr,
        isSearching: true,
      };
    });
    const handler = async () => {
      const storeId = globalState.staffInfo.checkOrderBranch.branchCode;
      const langId = globalState.langType;
      const date = state.dataPicker.selectTime;
      const status = state.dropDown.selectItem.value;

      let orderList = await apiOrderList(
        storeId,
        langStringToCode(langId),
        date,
        status
      );
      if (orderList) {
        let parserOrderList;
        if (orderList.length > 0) {
          parserOrderList = orderList.map((item) => ({
            customerInfo: {
              adult: item.adultsCount,
              branch: item.storeName,
              child: item.childCount,
              country: item.countryName,
            },
            isAddOrder: item.isAddOrder,
            orderCode: item.orderCode,
            // 非本日的單且未對單，前端皆顯示過期
            orderState:
              item.status === 1 &&
              Date.parse(item.createAt) -
                Date.parse(moment(new Date()).format("YYYY/MM/DD")) <
                0
                ? 7
                : item.status,
            // orderState: item.status,
            orderTime: item.createAt,
            queueNumber: item.queueNumber,
            posTableNo: item.posTableNo,
            totalPrice: item.totalPrice,
            id: item.id,
            posCode: item.posCode,
            orderExtraOptionList: item.orderExtraOptionList,
            lineIntable: item.lineIntable,
            lineIntableNo: item.lineIntableNo,
          }));
        } else {
          parserOrderList = [];
        }
        setState((curr) => {
          return {
            ...curr,
            orderList: parserOrderList,
            isSearching: false,
          };
        });
      }
    };
    // 有登入才執行
    if (state.isLogin) {
      handler();
    }
  }, [
    globalState.langType,
    state.isLogin,
    state.dropDown.selectItem,
    state.dataPicker.selectTime,
  ]);

  function parserOrderState(orderState) {
    switch (orderState) {
      case 1:
        return {
          txt: "pages.staffSearchOrder.dropDownItem.uncheck",
          style: "orderStateUncheck",
        };
      case 2:
        return {
          txt: "pages.staffSearchOrder.dropDownItem.check",
          style: "orderStateChecked",
        };
      case 4:
        return {
          txt: "pages.staffSearchOrder.dropDownItem.official",
          style: "orderStateOfficial",
        };
      case 6: {
        return {
          txt: "pages.staffSearchOrder.dropDownItem.checking",
          style: "orderStateChecking",
        };
      }
      case 0:
        return {
          txt: "pages.staffSearchOrder.dropDownItem.invalid",
          style: "orderStateExpired",
        };
      case 7:
        return {
          txt: "pages.staffSearchOrder.dropDownItem.expired",
          style: "",
        };
      default:
        throw Error(`parserOrderState error ${orderState}`);
    }
  }
  if (!state.isLogin) return null;

  return (
    <div className="Pages">
      <Header props={props} />
      <div className="col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
        <div className="Pages__section d-flex flex-column align-items-center pb-sm-4">
          <div className="Pages__title d-flex">
            <FormattedMessage
              id="pages.staffSearchOrder.title"
              children={(e) => {
                const { langType } = globalState;
                if (
                  langType !== "zh" &&
                  langType !== "ja" &&
                  langType !== "ko"
                ) {
                  const splitString = e.split(" ");
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                } else {
                  const splitString = e.split("");
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                }
              }}
            />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
          <span className="m-2">
            <Tool_storeName
              storeId={globalState.staffInfo.checkOrderBranch.branchCode}
            />
            {/* {globalState.staffInfo.checkOrderBranch.branchName} */}
          </span>
          <span className="m-2">
            {globalState.staffInfo.checkOrderGroup.groupName}
          </span>
          <span className="m-2">
            {globalState.staffInfo.checkOrderStaff.staffName}
          </span>
          <span className="m-2">
            {globalState.staffInfo.checkOrderStaff.staffNum}
          </span>
        </div>
        {/* search input & filter option */}
        <div className="Pages__section Pages__list p-2 pt-sm-3 pb-sm-3 border-bot-0">
          <div className="d-flex mb-3">
            <div className="col-sm-auto col-6 p-0">
              <DatePicker
                selected={moment(state.dataPicker.selectTime)._d}
                onChange={(date) => {
                  setState((curr) => {
                    let newState = { ...curr };
                    newState.dataPicker.selectTime =
                      moment(date).format("YYYY/MM/DD");
                    return newState;
                  });
                }}
                minDate={moment().subtract(1, "y")._d}
                maxDate={moment()._d}
                customInput={
                  <div
                    className="Pages__dropDown mr-2"
                    style={{
                      width: globalState.device === "pc" ? "200px" : "auto",
                    }}
                  >
                    <div className="Pages__dropDown__button p-2 pr-3 pl-3">
                      <span className="mr-4">
                        {moment(state.dataPicker.selectTime).format(
                          "YYYY/MM/DD"
                        )}
                      </span>
                    </div>
                  </div>
                }
              />
            </div>
            <div className="col-sm-auto col-6 p-0">
              <Dropdown
                className="Pages__dropDown ml-2"
                isOpen={state.dropDown.toggle}
                size="sm"
                style={{
                  width: globalState.device === "pc" ? "200px" : "auto",
                }}
                toggle={() =>
                  setState((curr) => {
                    let newState = { ...curr };
                    newState.dropDown.toggle = !newState.dropDown.toggle;
                    return newState;
                  })
                }
              >
                <DropdownToggle
                  caret
                  className="Pages__dropDown__button d-flex justify-content-start p-2 pr-3 pl-3"
                >
                  <span className="mr-4">
                    {}
                    <FormattedMessage
                      id={parserOrderState(state.dropDown.selectItem.value).txt}
                    />
                  </span>
                </DropdownToggle>
                <DropdownMenu className="Pages__dropDown__menu">
                  {(() => {
                    let stateList = [
                      { value: 1 },
                      { value: 2 },
                      { value: 4 },
                      { value: 6 },
                      { value: 0 },
                    ];

                    return stateList.map((eachState, stateIndex) => (
                      <DropdownItem
                        key={stateIndex}
                        className={cls(
                          "Pages__dropDown__li p-2",
                          state.dropDown.selectItem.value === eachState.value
                            ? "Pages__dropDown__li_selected"
                            : ""
                        )}
                        onClick={() => {
                          setState((curr) => {
                            let newState = { ...curr };
                            newState.dropDown.selectItem = {
                              value: eachState.value,
                            };
                            return newState;
                          });
                        }}
                      >
                        <FormattedMessage
                          id={parserOrderState(eachState.value).txt}
                        />
                      </DropdownItem>
                    ));
                  })()}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div className="d-flex align-items-center col-7 p-0">
              <FormattedMessage
                id="pages.staffSearchOrder.searchOrderInputPlaceholder"
                children={(msg) => {
                  return (
                    <CusInput
                      className="w-100 CusInput_search uppercase"
                      icon={<i className="icn ic_order_search__mobile" />}
                      maxLength={6}
                      placeholder={msg}
                      onChange={(event) => {
                        let val = event.target.value.trim().toUpperCase();
                        setState((curr) => {
                          let newState = { ...curr };
                          newState.searchInput = val;
                          return newState;
                        });
                      }}
                    />
                  );
                }}
              />
            </div>
            <div className="d-flex align-items-center justify-content-center col-3 p-0">
              <FormattedMessage
                id="pages.staffSearchOrder.orderTotal"
                defaultMessage="共 {count} 筆"
                values={{ count: state.orderList.length }}
              />
            </div>
            <div className="d-flex align-items-center justify-content-end col-2 p-0">
              <a
                onClick={() => {
                  setState((curr) => {
                    return {
                      ...curr,
                      isShowBlock: true,
                    };
                  });
                }}
              >
                <i
                  className={`icn ic_order_present_block${
                    state.isShowBlock ? "" : "_disabled"
                  }__mobile`}
                />
              </a>
              <a
                onClick={() => {
                  setState((curr) => {
                    return {
                      ...curr,
                      isShowBlock: false,
                    };
                  });
                }}
              >
                <i
                  className={`icn ic_order_present_detail${
                    !state.isShowBlock ? "" : "_disabled"
                  }__mobile`}
                />
              </a>
            </div>
          </div>
          {(() => {
            // 禁止顯示 tabs
            if (
              (isIOS && !isSafari) || // ios系統但瀏覽器非safari
              (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
            )
              return null;
            return (
              <>
                <div className="Tool Tool__tabs d-flex">
                  {verifyItems.map((e, index) => (
                    <a
                      key={index}
                      className={cls(
                        "Tool__tabs__item text-center d-flex col justify-content-center align-items-center pt-3 pb-3",
                        state.selectedTab === e.info
                          ? "Tool__tabs__item_seleted"
                          : "",
                        state.selectedTab,
                        e.className
                      )}
                      onClick={() => {
                        setState((curr) => {
                          return {
                            ...curr,
                            selectedTab: e.info,
                          };
                        });
                      }}
                    >
                      {e.title}
                      <span className="text-sm text-rose-800 ml-2">
                        (
                        {
                          state.orderList.filter((x) => {
                            return x.isAddOrder === e.Type;
                          }).length
                        }
                        )
                      </span>
                    </a>
                  ))}
                </div>
              </>
            );
          })()}
        </div>
        <div
          className={cls(
            "Order__list d-flex col p-0 pt-3 pb-3",
            state.isShowBlock ? "showBlock row" : "flex-column"
          )}
        >
          {(() => {
            if (state.isSearching)
              return (
                <div
                  className="w-100 h-100 d-flex align-items-center justify-content-center"
                  style={{
                    flex: "1 1 0",
                  }}
                >
                  <FormattedMessage
                    id="staffCheckOrder.searching"
                    defaultMessage="Searching..."
                  />
                </div>
              );

            if (!state.isSearching && state.orderList.length <= 0)
              return (
                <div
                  className="w-100 h-100 d-flex align-items-center justify-content-center"
                  style={{
                    flex: "1 1 0",
                  }}
                >
                  <FormattedMessage
                    id="staffCheckOrder.dataNoFound"
                    defaultMessage="Data not found."
                  />
                </div>
              );

            return (
              <>           
                {state.orderList
                  .filter((f) => {
                    const target = state.searchInput.toLowerCase();
                    return (
                      f.isAddOrder ===
                        (state.selectedTab === "firstorder" ? false : true) &&
                      (f.orderCode.toLowerCase().indexOf(target) > -1 ||
                        f.queueNumber.toString().indexOf(target) > -1)
                    );
                  })
                  .map((eachOrder, orderIndex) => (
                    <div
                      key={orderIndex}
                      className={cls(
                        "Pages__list p-2 pt-sm-3 pb-sm-3",
                        state.isShowBlock ? "col-6 col-lg-3" : ""
                      )}
                      // onClick={async () => {
                      //   const { langType } = globalState;
                      //   const storeID =
                      //     globalState.staffInfo.checkOrderBranch.branchCode;
                      //   const createAt = state.dataPicker.selectTime;
                      //   let orderDetail = await apiOrderDetail(
                      //     eachOrder.orderCode,
                      //     langStringToCode(langType),
                      //     storeID,
                      //     createAt
                      //   );
                      //   if (orderDetail) {
                      //     dispatchGlobal({
                      //       type: "UPDATE",
                      //       payload: [
                      //         {
                      //           key: "staffInfo",
                      //           val: {
                      //             ...globalState.staffInfo,
                      //             orderCode: eachOrder.orderCode,
                      //             createAt,
                      //           },
                      //         },
                      //       ],
                      //     });
                      //     window.document.body.scrollTop = 0;
                      //   }
                      // }}
                    >
                      <div
                        className="blockMode"
                        onClick={async () => {
                          const createAt = state.dataPicker.selectTime;
                          dispatchGlobal({
                            type: "UPDATE",
                            payload: [
                              {
                                key: "staffInfo",
                                val: {
                                  ...globalState.staffInfo,
                                  orderCode: eachOrder.orderCode,
                                  createAt,
                                },
                              },
                            ],
                          });
                          window.document.body.scrollTop = 0;
                        }}
                      >
                        {/* POS單號(沒帶則不顯示) */}
                        {eachOrder.posCode ? (
                          <>
                            <div className="d-flex mt-2 mb-2 align-items-center Pages__specification__title font-weight-bold">                         
                                <span className="ml-1 mr-1 blockHide">
                                  <FormattedMessage id="pages.staffSearchOrder.orderInfo.posNumber" />
                                </span>
                                <span className="ml-1 mr-1" style={{float:"left"}}>
                                  {eachOrder.posCode}
                                </span>                                                

                              {(eachOrder.isAddOrder)?
                                  null:
                                  (eachOrder.posTableNo )? 
                                    <span className="txtColorBrown blockShow text-sm ml-1 mr-1" style={{float:"right"}}>
                                      {eachOrder.posTableNo} <FormattedMessage id="pages.staffOrderDetail.table" />
                                    </span>: 
                                    (eachOrder.lineIntable )  ? 
                                      <span className="txtColorRed blockShow text-sm ml-1 mr-1" style={{float:"right"}}>
                                        {(eachOrder.lineIntable.slice(-1)==="桌") ? eachOrder.lineIntable.slice(0, -1):eachOrder.lineIntable} <FormattedMessage id="pages.staffOrderDetail.table" />
                                      </span>: 
                                      <span className="txtColorBrown blockShow text-sm ml-1 mr-1" style={{float:"right"}}>
                                        <FormattedMessage id="pages.all.NoTableNumber" />
                                    </span>
                                  }              
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2 mb-2 font-weight-bold blockHide">
                              <div className="mr-1">
                                {(eachOrder.posTableNo)?
                                  <span className="ml-1 mr-1">
                                    {eachOrder.posTableNo}<FormattedMessage id="pages.staffOrderDetail.table" />
                                  </span>
                                  :
                                  (eachOrder.lineIntable)?
                                    (
                                      <span className="txtColorRed ml-1 mr-1">                              
                                        {(eachOrder.lineIntable.slice(-1)==="桌") ? eachOrder.lineIntable.slice(0, -1):eachOrder.lineIntable}<FormattedMessage id="pages.staffOrderDetail.table" />
                                      </span>
                                    ):
                                    (
                                      <span className="ml-1 mr-1">
                                        <FormattedMessage id="pages.all.NoTableNumber" />
                                      </span>
                                    )                                
                                }
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="d-flex justify-content-between align-items-center mt-2 mb-2 Pages__specification__title font-weight-bold">
                            <div className="mr-1">
                              {(eachOrder.lineIntable) ?
                               (  
                                <span className="txtColorRed ml-1 mr-1">
                                  {(eachOrder.lineIntable.slice(-1)==="桌") ? eachOrder.lineIntable.slice(0, -1):eachOrder.lineIntable}<FormattedMessage id="pages.staffOrderDetail.table" />
                                </span>):
                               (
                                <span className="ml-1 mr-1">                              
                                  <FormattedMessage id="pages.all.NoTableNumber" />
                                </span>
                               )
                              }                              
                            </div>
                          </div>
                        )}                                         
                        <div className="d-flex justify-content-between align-items-center mt-2 mb-2 blockHide">
                          <div className="mr-2">
                            <span className="ml-1 mr-1">
                              {eachOrder.orderTime}
                            </span>
                          </div>
                          <div className="ml-2">
                            <span
                              className={cls(
                                "ml-1 mr-1",
                                parserOrderState(eachOrder.orderState).style
                              )}
                            >
                              <FormattedMessage
                                id={parserOrderState(eachOrder.orderState).txt}
                              />
                            </span>
                          </div>
                        </div>
                        <div
                          className={cls(
                            "d-flex align-items-center mt-2 mb-2",
                            globalState.device === "pc"
                              ? ""
                              : "justify-content-between",
                            state.isShowBlock ? "justify-content-between" : ""
                          )}
                        >
                          {state.isShowBlock ? (
                            <>
                              <span className="ml-1 mr-1 queueNumber orderInfo txtColorBrown">
                                {eachOrder.isAddOrder
                                  ? eachOrder.posTableNo
                                  : eachOrder.queueNumber}
                                {/* {eachOrder.queueNumber > 9999 ? '----' : eachOrder.queueNumber} */}
                              </span>
                              <span className="ml-1 mr-1 orderInfo txtColorLightGreen">
                                {eachOrder.orderCode}
                              </span>
                              <span className="ml-1 mr-1 orderInfo txtColorBrown">
                                {eachOrder.customerInfo.country}
                              </span>
                             
                              <span className="txtColorBrown">
                                {eachOrder.orderExtraOptionList.length > 0
                                  ? eachOrder.orderExtraOptionList[0].sign
                                  : ""}
                              </span>
                            </>
                          ) : (
                            <>
                              <div className="mr-2">
                                <span className="ml-1 mr-1 blockHide">
                                  <FormattedMessage id="pages.staffSearchOrder.queueNumber" />
                                </span>
                                <span className="ml-1 mr-1 queueNumber orderInfo txtColorBrown">
                                  {eachOrder.queueNumber}
                                  {/* {eachOrder.queueNumber > 9999 ? '----' : eachOrder.queueNumber} */}
                                </span>
                              </div>
                              <div className="ml-2">
                                <span className="ml-1 mr-1 blockHide">
                                  <FormattedMessage id="pages.staffSearchOrder.orderCode" />
                                </span>
                                <span className="ml-1 mr-1 orderInfo txtColorLightGreen">
                                  {eachOrder.orderCode}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2 mb-2 blockHide">
                          <div className="mr-2">
                            <p className="m-0 ml-1 mr-1">
                              <span className="mr-1">
                                {eachOrder.customerInfo.branch}
                              </span>
                              <span className="mr-1">
                                {eachOrder.customerInfo.adult}
                                <FormattedMessage id="pages.staffSearchOrder.adult" />
                              </span>
                              <span className="mr-1">
                                {eachOrder.customerInfo.child}
                                <FormattedMessage id="pages.staffSearchOrder.child" />
                              </span>
                              <span className="mr-1">
                                {eachOrder.customerInfo.country}
                              </span>
                            </p>
                          </div>
                          <div className="ml-2">
                            <span className="ml-1 mr-1 txtColorBrown">
                              $ {numeral(eachOrder.totalPrice).format("0,0.00")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            );
          })()}
        </div>
        <div className="flex-column col p-0">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default StaffSearchOrder;
